var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoiceTableTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_21356",
    "data-name": "Group 21356",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6214",
    "data-name": "Rectangle 6214",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_19",
    "data-name": "Union 19",
    d: "M7.556,13.484V9.1A1.736,1.736,0,0,1,9.308,7.385h6.139A1.737,1.737,0,0,1,17.2,9.1v4.384a4.823,4.823,0,0,1-9.644,0ZM9.172,9.1v4.384a3.078,3.078,0,0,0,.935,2.217,3.275,3.275,0,0,0,4.54,0,3.078,3.078,0,0,0,.935-2.217V9.1a.124.124,0,0,0-.136-.131H9.308A.124.124,0,0,0,9.172,9.1ZM0,13.484V9.1A1.736,1.736,0,0,1,1.752,7.385H7.521l-.14.165a2.393,2.393,0,0,0-.56,1.329l-.008.09H1.752a.134.134,0,0,0-.136.131v4.384a3.172,3.172,0,0,0,3.206,3.131,3.209,3.209,0,0,0,2.3-.962l.1-.1.06.132a5.427,5.427,0,0,0,.738,1.187l.061.076-.073.064A4.877,4.877,0,0,1,4.822,18.2,4.775,4.775,0,0,1,0,13.484ZM8.972,3.33a3.406,3.406,0,0,1,6.811,0,3.406,3.406,0,0,1-6.811,0Zm1.616,0a1.789,1.789,0,1,0,1.789-1.746A1.75,1.75,0,0,0,10.589,3.33Zm-9.172,0A3.372,3.372,0,0,1,4.822,0,3.373,3.373,0,0,1,8.228,3.33,3.373,3.373,0,0,1,4.822,6.661,3.372,3.372,0,0,1,1.417,3.33Zm1.616,0A1.75,1.75,0,0,0,4.822,5.077a1.747,1.747,0,1,0,0-3.493A1.749,1.749,0,0,0,3.033,3.33Z",
    transform: "translate(3.4 2.9)",
    fill: "#032983"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceTableTeam);
export default __webpack_public_path__ + "static/media/voice_table_team.05ac6ecc0c594e9014e7eb6d02d89ebd.svg";
export { ForwardRef as ReactComponent };